<script setup lang="ts">
import { ColumnData, ButtonAlign } from '~~/server/api/pagebuilder'

export interface PagebuilderButtonContainerProps {
    data: ColumnData
}

const props = defineProps<PagebuilderButtonContainerProps>()

const getButtonsAlign = computed<string>((): string => {
    const align = {
        left: 'justify-content-start',
        center: 'justify-content-center',
        right: 'justify-content-end',
    }[props.data.buttons_align as ButtonAlign]

    return align
})

</script>

<template>
  <div
    class="d-flex gap-4 flex-wrap"
    :class="[getButtonsAlign]"
  >
    <VButton
      v-for="(button, index) in props.data.buttons"
      :key="`btn-${index}`"
      :to="button.url"
      :color="button.type"
      class="mb-4"
      :target="button.target_blank === '1' ? '_blank' : '_self'"
    >
      {{ button.name }}
    </VButton>
  </div>
</template>